/* import __COLOCATED_TEMPLATE__ from './admin-firstname.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();